import { render, staticRenderFns } from "./claim_content.vue?vue&type=template&id=4970bd14&scoped=true"
import script from "./claim_content.vue?vue&type=script&lang=js"
export * from "./claim_content.vue?vue&type=script&lang=js"
import style0 from "./claim_content.vue?vue&type=style&index=0&id=4970bd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970bd14",
  null
  
)

export default component.exports